import { render, staticRenderFns } from "./top-logs.vue?vue&type=template&id=abdb1916&scoped=true&"
import script from "./top-logs.vue?vue&type=script&lang=js&"
export * from "./top-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdb1916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abdb1916')) {
      api.createRecord('abdb1916', component.options)
    } else {
      api.reload('abdb1916', component.options)
    }
    module.hot.accept("./top-logs.vue?vue&type=template&id=abdb1916&scoped=true&", function () {
      api.rerender('abdb1916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/top/top-logs.vue"
export default component.exports